/**
 * -----------------------------------------------------------------------------
 * It renders the VideoSquareIcon icon
 */
export function VideoSquareIcon() {
  return (
    <svg
      className="size-8"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path d="m16.663 14.535-2.187-1.348v-2.374l2.187-1.348a.55.55 0 0 1 .84.468v4.134a.55.55 0 0 1-.84.468Z" />

      <rect height={7.153} rx={1.65} width={7.978} x={6.498} y={8.423} />

      <rect height={18.008} rx={5} width={18.008} x={2.996} y={2.996} />
    </svg>
  );
}
